import router from "@/router";
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbq?: any;
  }
}
// Merchant ID for 1P ecommerce tracking, only 1P is supposed to be tracked since that's where we put ads
const merchantId1PEcommerce = 247680;

// Global flag to track pixel initialization
let isPixelInitialized = false;

export const enablePixel = (pixelId: string, merchantId: number): void => {
  try {
    if (
      typeof window.fbq === "function" &&
      process.env.NODE_ENV === "production" &&
      !isPixelInitialized &&
      merchantId === merchantId1PEcommerce // We are only tracking 1P ecommerce events
    ) {
      window.fbq("init", pixelId);
      router.afterEach(() => {
        window.fbq("track", "PageView");
      });
      isPixelInitialized = true;
    }
  } catch (error) {
    console.warn("Failed to initialize Facebook Pixel:", error);
  }
};

export const trackEvent = (
  eventName: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventData?: Record<string, any>
): void => {
  try {
    if (
      typeof window.fbq === "function" &&
      process.env.NODE_ENV === "production" &&
      isPixelInitialized
    ) {
      window.fbq("trackCustom", eventName, eventData);
    }
  } catch (error) {
    console.warn("Failed to track Facebook Pixel event:", error);
  }
};
